// Firebase 11 modular API
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCgSe6odkXqddW638r2zqycybQwcCBejns',
  authDomain: 'merchant-apps-pertamina.firebaseapp.com',
  projectId: 'merchant-apps-pertamina',
  storageBucket: 'merchant-apps-pertamina.appspot.com',
  messagingSenderId: '125478743265',
  appId: '1:125478743265:web:fab0b4024c6415d8675ba0',
  measurementId: 'G-TTV8E60J73',
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };
